import { ListItem as ListItemToExtend } from '@tiptap/extension-list-item';

export const ListItem = ListItemToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
});
